// extracted by mini-css-extract-plugin
export default {"dots":"aYISzq","delay":"bYISzq","dot":"cYISzq","active":"dYISzq","autoplay":"eYISzq"};